<script>
export default {
    name: 'GcepRecurationProcessLink',
    props: {
        
    },
    data() {
        return {
            
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>
<template>
  <a target="gcep-recuration-process" href="https://clinicalgenome.org/site/assets/files/2164/clingen_standard_gene-disease_validity_recuration_procedures_v1.pdf">
    <slot>Gene-Disease Validity Recuration Process document</slot>
  </a>
</template>